import React from 'react'
import cx from 'classnames'
import Icon from 'svg-inline-react'

import Avatar from 'shared-web/src/components/Avatar'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import UISelect from 'components/shared/UISelect'
import FakeEmailWindow from 'components/shared/FakeEmailWindow'
import LoadingDots from 'components/shared/LoadingDots'

import Card from '../Card'

import infoSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/icons/info-icon.svg'

import './style.styl'

const HELP_DOC_LINK = 'https://help.drift.com/article/personalization-tokens/'
const HELP_LINK_TEXT = 'Click here to learn more about using personalization attributes in a Drift playbook.'

const SimpleEmailTemplate = ({ fromName, fromEmail, headline, messagePreview, showRenderedPreview }) => (
  <FakeEmailWindow from={fromName} address={fromEmail} subject={headline}>
    <div className={cx("playbook-email-template-content", { 'playbook-email-template-data-preview': showRenderedPreview })} dangerouslySetInnerHTML={{ __html: messagePreview }} />
  </FakeEmailWindow>
)

const StyledEmailTemplate = ({
  sender,
  fromName,
  fromEmail,
  headline,
  messagePreview,
  backgroundColor,
  organizationName,
  showRenderedPreview
}) => (
  <FakeEmailWindow from={fromName} address={fromEmail} subject={headline}>
    <div className="playbook-email-template-styled-top-bar" style={{ backgroundColor: backgroundColor }} />
    <div className="playbook-email-template-styled-container">
      <div className={cx("playbook-email-template-content", { 'playbook-email-template-data-preview': showRenderedPreview })} dangerouslySetInnerHTML={{ __html: messagePreview }} />
      {sender &&
        sender.name && (
          <div className="flex playbook-email-template-styled-signature">
            <Avatar user={sender} />
            <div>
              <div className="playbook-email-template-styled-signature-name">{getDisplayName(sender)}</div>
              <div className="playbook-email-template-styled-signature-organization">{organizationName}</div>
            </div>
          </div>
        )}
    </div>
  </FakeEmailWindow>
)

const ThemeOption = ({ color, selected, type, onClick }) => (
  <div className={cx('playbook-email-theme-option', { selected })} onClick={onClick}>
    <div className="playbook-email-theme-option-swatch" style={{ backgroundColor: color }} />
    {type}
  </div>
)

const EmailMessagePreview = ({
  headline,
  message,
  selectedUser,
  organizationName,
  backgroundColor,
  simpleSelected,
  styledSelected,
  onStyledClick,
  onSimpleClick,
  sendTestEmailLoading,
  onSendTestEmailClick,
  showRenderedPreview,
  emailRenderedPreview,
  selectedPreview,
  onDefaultPreviewClick,
  onTemplatePreviewClick,
  onRenderedPreviewClick,
  onRefreshPreviewClick,
  userListIdOptions,
  handleChangeUserListOption,
  selectedUserListOption,
  EmailPreviewView,
  fromNameOverride,
  fromEmailOverride,
  isTemplateContactPreviewLoading,
}) => {
  const messagePreview =
    selectedPreview !== EmailPreviewView.TEMPLATE && emailRenderedPreview ? emailRenderedPreview : message
  const templateProps = {
    messagePreview,
    headline,
    sender: selectedUser,
    fromName: fromNameOverride || getDisplayName(selectedUser),
    fromEmail: fromEmailOverride,
    showRenderedPreview,
    emailRenderedPreview,
  }
  return (
    <div className="playbook-message">
      <h2>How should your email look?</h2>
      <h3>Choose a plain text or styled email.</h3>
      <Card title="Email" description={headline}>
        {simpleSelected && <SimpleEmailTemplate {...templateProps} />}
        {styledSelected && (
          <StyledEmailTemplate
            {...templateProps}
            backgroundColor={backgroundColor}
            organizationName={organizationName}
          />
        )}
      </Card>
      <div className="email-playbook-extra-option">
        <div className="email-playbook-preview-options">
          <label className="preview-options-label">
            Preview Sample Data{' '}
            <a is href={HELP_DOC_LINK} tooltip={HELP_LINK_TEXT} flow="up" target="_blank">
              <Icon src={infoSrc} />
            </a>
          </label>
          <div className="drift-pill-set">
            <button
              onClick={onTemplatePreviewClick}
              className={cx('drift-button', 'playbook-extra-option-button', {
                active: selectedPreview === EmailPreviewView.TEMPLATE,
              })}
            >
              Template
            </button>
            <button
              onClick={onDefaultPreviewClick}
              className={cx('drift-button', 'playbook-extra-option-button', {
                active: selectedPreview === EmailPreviewView.DEFAULTS,
              })}
            >
              Defaults
            </button>
            <button
              onClick={onRenderedPreviewClick}
              className={cx('drift-button', 'playbook-extra-option-button', {
                active: selectedPreview === EmailPreviewView.RENDERED_DATA,
              })}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
      {selectedPreview === EmailPreviewView.RENDERED_DATA && (
        <div className="email-playbook-extra-option email-playbook-segment-option">
          <UISelect
            className="playbook-email-preview-segment-select"
            options={userListIdOptions}
            value={selectedUserListOption}
            onChange={handleChangeUserListOption}
            placeholder={'choose a segment..'}
          />
          <div>
            <button disabled={isTemplateContactPreviewLoading} onClick={onRefreshPreviewClick} className="drift-button playbook-extra-option-button">
              {isTemplateContactPreviewLoading &&
                <div className="email-preview-options-loading-container"><LoadingDots /></div>
              }
              {!isTemplateContactPreviewLoading &&
                'Refresh'
              }
            </button>
          </div>
        </div>
      )}
      <div className="email-playbook-extra-option">
        <label>Select a Theme</label>
        <div>
          <ThemeOption type="Styled" selected={styledSelected} color={backgroundColor} onClick={onStyledClick} />
          <ThemeOption type="Simple" selected={simpleSelected} onClick={onSimpleClick} />
        </div>
      </div>
      <div className="email-playbook-extra-option">
        <label>Send me a test email</label>
        <div>
          <button
            className="drift-button playbook-extra-option-button"
            disabled={sendTestEmailLoading}
            onClick={onSendTestEmailClick}
          >
            {sendTestEmailLoading &&
              <div className="email-preview-options-loading-container"><LoadingDots /></div>
            }
            {!sendTestEmailLoading &&
              'Send Email'
            }
          </button>
        </div>
      </div>
    </div>
  )
}

export default EmailMessagePreview



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailMessagePreview/component.js